import { isEmpty, capitalize } from 'lodash-es';

const functions = {
  hashCode(str) {
    let hash = 0;
    let i;
    let chr;
    for (i = 0; i < str.length; i += 1) {
      chr = str.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = ((hash << 5) - hash) + chr;
      // eslint-disable-next-line no-bitwise
      hash |= 0;
    }
    return hash;
  },
  camelToKebabCase(text) {
    if (text === null || text === undefined) {
      return text;
    }
    let result = '';
    let upper = 0;
    let numeric;
    const string = String(text);
    for (let i = 0; i < string.length; i += 1) {
      const ch = string[i];
      const chLower = ch.toLowerCase();
      if (ch !== chLower) {
        const prev = result[result.length - 1];
        if (upper > 1 && result.length > 1) {
          result = result.slice(0, result.length - 2) + prev;
        }
        if (result.length && prev !== '-'
                && prev !== ' ' && prev !== '\t' && prev !== '\r' && prev !== '\n'
        ) {
          result += '-';
        }
        result += chLower;
        upper += 1;
        numeric = false;
      } else if (ch.charCodeAt(0) >= 48 && ch.charCodeAt(0) <= 57) {
        if (numeric === false && result[result.length - 1] !== '-') {
          result += '-';
        }
        result += ch;
        upper = 0;
        numeric = true;
      } else if (numeric && result[result.length - 1] !== '-') {
        result += `-${ch}`;
        upper = 0;
        numeric = false;
      } else {
        result += ch;
        upper = 0;
        numeric = false;
      }
    }
    if (upper > 1 && result.length > 1) {
      result = result.slice(0, result.length - 2) + result[result.length - 1];
    }
    return result;
  },
  isEmpty(string) {
    return string === null || string === undefined || string === '';
  },
  capitalize(string) {
    if (!string.length) {
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  addressFormatter(company) {
    let addressFormatted = '';
    const { address } = company;
    if (!isEmpty(address.street)) {
      addressFormatted += address.street.toLowerCase();
      if (!isEmpty(address.city)) {
        addressFormatted += ', ';
      }
    }
    if (!isEmpty(address.city)) {
      addressFormatted += capitalize(address.city.toLowerCase());
    }
    if (!isEmpty(address.postalCode) && !isEmpty(address.country)) {
      addressFormatted += ' - ';
    }
    addressFormatted += `${address.postalCode || ''} ${address.country || ''}`;
    return addressFormatted.trim();
  },
  filename(name) {
    if (name) {
      const nameReplaced = name.replace(/\.pdf/g, ' ').split('_').join(' ');
      return capitalize(nameReplaced);
    }
    return '';
  },
  parseQueryString(str) {
    const objURL = {};

    str.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      ($0, $1, $2, $3) => {
        objURL[$1] = $3;
      },
    );
    return objURL;
  },
};

export default functions;
